<bspk-touch-target />

@if (icon(); as name) {
  <bspk-icon data-button-icon [name]="name" />
}

@if (!hideLabel()) {
  <span data-button-label><ng-content /></span>
}
